import { BlockDataForm } from '@plone/volto/components';
import PropTypes from 'prop-types';
import { schemaListing } from '@arpav/components/ArpavTheme/Blocks/DoubleListing/schema';
import { useIntl } from 'react-intl';

const ListingData = props => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = schemaListing({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

ListingData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default ListingData;
